<template>
  <Container @focusout="isOpen = false" tabindex="0">
    <Title>{{ this.title }}</Title>
    <SelectedOption :last="this.last" @click="isOpen = !isOpen">{{
      renderSelectedOption(selectedOptions)
    }}</SelectedOption>
    <Options :open="isOpen">
      <Option @click="handleResetOptions()" :multipleActive="selectedOptions.length === 0"
        >All {{ this.title }}
      </Option>
      <Option
        v-for="option in this.options"
        :key="option"
        @click="handleSelectOption(option)"
        :multipleActive="selectedOptions.includes(option)"
        >{{ option }}
      </Option>
    </Options>
  </Container>
</template>

<script>
import { equals, cond, isEmpty, always, T, head, pipe, length } from 'ramda';

import { Container, Option, Options, Title, SelectedOption } from './dropdown.styles';

export default {
  components: { Container, Option, Options, Title, SelectedOption },
  props: {
    options: Array,
    title: String,
    last: Boolean,
    selectedOptions: { type: Array, default: () => [] },
    action: Function,
    resetAction: Function,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    handleSelectOption(data) {
      this.action(data);
    },
    handleResetOptions() {
      this.resetAction();
    },
    renderSelectedOption(selectedOptions) {
      return cond([
        [isEmpty, always(`All ${this.title}`)],
        [pipe(length, equals(1)), head],
        [T, always(`Multiple ${this.title}`)],
      ])(selectedOptions);
    },
  },
};
</script>
